import css from 'styled-jsx/css';
import { zIndex } from '../../../config/styles';

const ImageGalleryAdditionalButtonsStyles = css`
  .image-gallery-additional-buttons {
    position: absolute;
    bottom: 16px;
    right: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 10px;
    z-index: ${zIndex.imageGallery.button};
  }

  .button-container {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #fefeff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .image-gallery-additional-buttons {
      bottom: 12px;
      right: 12px;
      gap: 10px;
    }

    .button-container {
      width: 32px;
      height: 32px;
    }
  }

  @media (max-width: 480px) {
    .image-gallery-additional-buttons {
      bottom: 8px;
      right: 8px;
      gap: 8px;
    }

    .button-container {
      width: 32px;
      height: 32px;
    }
  }

  .hide {
    display: none;
  }
`;

export { ImageGalleryAdditionalButtonsStyles };
